import { path } from 'ramda';

import { rootStateBranchSelector } from '../utils/rootStateBranchSelector';

export const getHttpApi = path(['httpApi']);

export const getConfig = path(['config']);

export const getResults = path(['results']);

export const selectH1 = path<string | null>(['results', 'seo', 'h1']);

export const resultsSelector = rootStateBranchSelector('results');

export const breadcrumbsSelector = rootStateBranchSelector('breadcrumbs');
